import { render, staticRenderFns } from "./QuadroHorarioTurmaPage.vue?vue&type=template&id=5086aa23&scoped=true"
import script from "./QuadroHorarioTurmaPage.vue?vue&type=script&lang=js"
export * from "./QuadroHorarioTurmaPage.vue?vue&type=script&lang=js"
import style0 from "./QuadroHorarioTurmaPage.vue?vue&type=style&index=0&id=5086aa23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5086aa23",
  null
  
)

export default component.exports